import React from 'react';
import { Link } from 'react-router-dom';
import './Partners.css';
import heroImage from '../assets/hero-waterfront.jpg';
import BrandMark from './BrandMark';
import FaqAccordion from './FaqAccordion';

function Partners() {
  return (
    <main className="App-main partners-page">
      <section className="partners-hero">
        <div className="partners-hero-content">
          <p className="partners-eyebrow">Partner Program</p>
          <h1>Grow your revenue by helping landlords win with <BrandMark />.</h1>
          <p className="partners-subtitle">
            <BrandMark /> helps landlords lease faster, screen smarter, and collect rent on time — with no added cost to landlords.
            You bring the relationships; we deliver a product they keep paying for.
          </p>
          <div className="partners-hero-actions">
            <Link to="/contact" className="primary-button">Become a Partner</Link>
            <Link to="/contact" className="secondary-button">Inquire about Revenue Share</Link>
          </div>
          <div className="partners-hero-metrics">
            <div>
              <h3>1.7M</h3>
              <p>Renter households in Ontario</p>
            </div>
            <div>
              <h3>$49B+</h3>
              <p>Annual rent flow in Ontario</p>
            </div>
            <div>
              <h3>20.7M</h3>
              <p>Rent transactions per year (TAM)</p>
            </div>
            <div>
              <h3>7.6M</h3>
              <p>Self‑serve landlord transactions (est.)</p>
            </div>
          </div>
        </div>
        <div className="partners-hero-visual">
          <img src={heroImage} alt="Modern rentals with rentual.co" />
        </div>
      </section>

      <section className="partners-section partners-proof">
        <div className="partners-proof-card">
          <h2>Why partners choose <BrandMark /></h2>
          <p className="status-text">
            Landlords get a premium experience, and you build a recurring revenue stream that compounds with every referral.
          </p>
          <div className="partners-proof-grid">
            <div className="card">
              <h3>Faster leasing</h3>
              <p className="status-text">Invite-only applications, document intelligence, and instant booking.</p>
            </div>
            <div className="card">
              <h3>Smarter screening</h3>
              <p className="status-text">AI-powered risk scoring that flags issues before a lease is signed.</p>
            </div>
            <div className="card">
              <h3>Rent on autopilot</h3>
              <p className="status-text">Automated rent collection, receipts, and late‑payment workflows.</p>
            </div>
            <div className="card">
              <h3>Premium UX</h3>
              <p className="status-text">Modern landlord + tenant experience that sticks.</p>
            </div>
          </div>
        </div>
      </section>

      <section className="partners-section">
        <div className="partners-split">
          <div>
            <h2>Who this is for</h2>
            <ul className="partners-list">
              <li>Realtors and leasing agents</li>
              <li>Property managers and boutique firms</li>
              <li>Brokerages & team leads</li>
              <li>Service pros (maintenance, inspections, bookkeeping)</li>
            </ul>
            <div className="card partners-anyone-card">
              <h3>Anyone who can drive paying customers</h3>
              <p className="status-text">
                If you can refer registered landlords who activate a paid plan, we’ll build a partner path with you.
                Exposure is welcome — but we optimize for paid conversions.
              </p>
            </div>
          </div>
          <div className="partners-highlight card">
            <h3>Revenue share options</h3>
            <p className="status-text">Choose a model that fits how you work. Partner earnings come from <BrandMark />’s platform fees — no added landlord markup.</p>
            <ul>
              <li>Referral bonus per activated landlord</li>
              <li>% share of subscription revenue</li>
              <li>% share of payment fee revenue</li>
              <li>Revenue share per transaction processed</li>
              <li>Tiered volume incentives for top partners</li>
            </ul>
            <Link to="/contact" className="secondary-button">Get a custom partner plan</Link>
          </div>
        </div>
      </section>

      <section className="partners-section partners-steps">
        <h2>How it works</h2>
        <div className="partners-steps-grid">
          <div className="card">
            <span className="partners-step">01</span>
            <h3>Introduce <BrandMark /></h3>
            <p className="status-text">Share <BrandMark /> with your landlords or add it as your default workflow.</p>
          </div>
          <div className="card">
            <span className="partners-step">02</span>
            <h3>Landlords activate</h3>
            <p className="status-text">They onboard, list properties, and start receiving applications.</p>
          </div>
          <div className="card">
            <span className="partners-step">03</span>
            <h3>You earn recurring revenue</h3>
            <p className="status-text">We track your referrals and pay you monthly.</p>
          </div>
        </div>
      </section>

      <section className="partners-section partners-kpis">
        <div className="partners-kpis-inner">
          <h2>Performance metrics you can share</h2>
          <div className="partners-kpi-grid">
            <div className="card">
              <h3>Fewer vacancy days</h3>
              <p className="status-text">Streamlined inquiries + instant booking workflows.</p>
            </div>
            <div className="card">
              <h3>Higher quality applicants</h3>
              <p className="status-text">AI verification and document scoring keep standards high.</p>
            </div>
            <div className="card">
              <h3>Cleaner rent collection</h3>
              <p className="status-text">Autopay, receipts, and fee controls built in.</p>
            </div>
            <div className="card">
              <h3>Transactions processed</h3>
              <p className="status-text">Revenue share tied to each payment transaction.</p>
            </div>
          </div>
        </div>
      </section>

      <section className="partners-section partners-faq">
        <div className="partners-faq-inner">
          <h2>FAQ</h2>
          <FaqAccordion items={[
            { question: 'How do I get paid?', answer: 'Monthly payouts with full referral tracking and reporting.' },
            { question: 'Is it exclusive?', answer: 'No. We only require a strong fit and clear expectations.' },
            { question: 'Can we customize pricing?', answer: 'Yes. We can tailor incentives based on portfolio size and volume.' }
          ]} />
        </div>
      </section>

      <section className="partners-section partners-cta">
        <div className="partners-cta-card">
          <h2>Let’s build your partner channel.</h2>
          <p className="status-text">Tell us about your portfolio or referral volume and we’ll build a plan that fits.</p>
          <Link to="/contact" className="primary-button">Start the partner conversation</Link>
        </div>
      </section>
    </main>
  );
}

export default Partners;
